import request from '@/utils/request'

//根据操作台查询数据
export const getOperationNameByMac = (mac: string, data: string) =>
    request.monitorService({
        url: '/Yto_MonitorGateway/device/getOperationNameByMac?mac=' + mac,
        method: 'post',
        data
    })